import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import Ad from '@ifeng-fe/ui_pc_ad';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Header from './header';
import Content from './content';
import InsertHtml from '../components/insertHtml';
import Footer from './footer';
import ToTop from '../../components/toTop';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const {
            content: {
                topAd,
                nav,
                search,
                logo,
                logoAd,
                bannerPic,
                lvrenNoteTab,
                linkFengUrl,
                lvrenNote,
                cooperation,
                footer,
                bottomAd,
            },
        } = this.props;

        const headerData = {
            nav,
            search,
            topAd,
            logo,
            logoAd,
        };

        const contentData = {
            bannerPic,
            lvrenNoteTab,
            linkFengUrl,
            lvrenNote,
        };

        return (
            <div className={styles.content}>
                <Header content={headerData} />
                <Content content={contentData} />

                <div className={styles.feet}>
                    <div className={styles.col_wbf}>
                        <div className={styles.col_w1000}>
                            <div className={styles.space01}>&nbsp;</div>
                            <Chip id="30043" type="static" title="底部合作" groupName="content" content={cooperation}>
                                <InsertHtml />
                            </Chip>
                            <Ad content={bottomAd} styleName={styles.box} />
                            <Chip id="20036" type="struct" title="底部公用版权" groupName="底部" content={footer}>
                                <Footer />
                            </Chip>
                        </div>
                    </div>
                </div>

                <ToTop />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
